import React from 'react';
import './lectura.css'
import facebook from './Imagenes/Facebook_f_logo_(2019).svg.webp';
import x from './Imagenes/X_logo_2023_original.svg'
import  usicamm from './Imagenes/Usicamm-logo.png';

const Footer = () => {
    return ( 
        <>
            <footer>
            <ul className="social-icons">
  <li></li>
  <li><a href="https://www.facebook.com/USICAMM" target="_blank" rel="noopener noreferrer"><img className='facebook' src={facebook} alt="Facebook" /></a></li>
  <li><a href="https://twitter.com/USICAMM_OFICIAL?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank" rel="noopener noreferrer"><img className='x' src={x} alt="X" /></a></li>
  <li><a href="http://usicamm.sep.gob.mx/" target="_blank" rel="noopener noreferrer"><img className='usicamm' src={usicamm} alt="Página Web" /></a></li>
</ul>


  <p>¡Síguenos en redes sociales y visita nuestra página web!</p>
</footer>


        </>
     
             );
}
 
export default Footer;